import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

export const CorticosteroidPharmacistAdvice: FC = () => (
  <p className="text-s">
    <FormattedMessage id="qualityIndicator.glukokortikoid.p" />
  </p>
)
